import { Platforms } from '../../types';

import { getInternalPath } from './getInternalPath';
import { getVersionedPath } from './getVersionedPath';
import { segmentize } from './segmentize';

export const pathToPreviousVersion = (
  key: string | undefined,
  name: string,
  pathname: string,
  platform: string | undefined,
  version: string | undefined,
  slug: string,
  defaultVersion: string | undefined,
  allSlugs: string[],
  platforms: Platforms | undefined,
): string => {
  if (!key) {
    return '/';
  }

  const path = getInternalPath(
    getVersionedPath(key, slug, defaultVersion, version, !!platforms),
    pathname,
    name,
  );

  // check if the new location is actually a page
  if (allSlugs.includes(path)) {
    return path;
  }

  let redirectPath = '/';

  if (platform) {
    const segments = segmentize(path);
    const index =
      key === defaultVersion
        ? segments.indexOf(platform)
        : segments.indexOf(key);
    // redirect to the platform entry point of the version
    redirectPath = segments.slice(0, index + 1).join('/');
  } else {
    redirectPath = key === defaultVersion ? '/' : key;
  }

  return getInternalPath(redirectPath, pathname, name);
};
